var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentBlock paddingTop contract"},_vm._l((_vm.processedHtml),function(block,index){return _c('fragment',{key:index},[(block.type === 'component')?_c(block.component,_vm._b({tag:"component"},'component',block.props,false)):[_c('fragment',{domProps:{"innerHTML":_vm._s(block.content)}})]],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }